import { InfluxSeriesMeasuresData } from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/sharedV2'
import { debounce } from '@mv-submodules/mvlabs-components-fe/functions/helpers/functionHelper'
import { useState } from 'react'
import { useCallback, useEffect, useMemo } from 'react'

interface Props {
  data: InfluxSeriesMeasuresData
}

interface UseBrushResult {
  brushStartIndex: number
  brushEndIndex: number
  handleBrush: (args: any) => void
  filteredData: InfluxSeriesMeasuresData
}

function useDataBrush(props: Props): UseBrushResult {
  const { data } = props
  const [brushState, setBrushState] = useState({ brushStartIndex: 0, brushEndIndex: 0 })

  const handleBrush = useCallback((args: any) => {
    setBrushState({ brushStartIndex: args.startIndex, brushEndIndex: args.endIndex })
  }, [])

  const handleBrushWithDebounce = useMemo(() => debounce(handleBrush, 10), [handleBrush])

  useEffect(() => {
    setBrushState({ brushStartIndex: 0, brushEndIndex: data.length ?? 0 })
  }, [data])

  const filteredData = useMemo(() => data.slice(brushState.brushStartIndex, brushState.brushEndIndex + 1), [
    data,
    brushState,
  ])

  return {
    brushStartIndex: brushState.brushStartIndex,
    brushEndIndex: brushState.brushEndIndex,
    handleBrush: handleBrushWithDebounce,
    filteredData,
  }
}

export default useDataBrush
